<script lang="ts" setup>
useHead({
    style: [
        {
            innerHTML: useFonts(),
        },
    ],
    htmlAttrs: { lang: 'sk' },
})

const error = useError()
const config = useRuntimeConfig()
</script>
<template>
  <article>
    <img
      :src="`${config.app.cdnURL}/${config.public.PUBLIC_IMAGES_URL}/404.png`"
      alt="404"
      width="462"
      height="259"
      class="d-block img-fluid mx-auto mb-8"
    >
    <h1 class="text-center mb-2">
      {{
        !error?.message || ['Error', 'Server Error'].some((message) => message.toLowerCase() === error?.message.toLowerCase())
          ? $t('Stránku sme nenašli')
          : error.message
      }}
    </h1>
    <h2 class="text-center text-black delta mb-7">
      {{ $t('Pomôžeme vám nájsť, čo hľadáte') }}
    </h2>
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <SearchForm
          control-name="q"
          :submit="true"
          :placeholder="$t('Zadajte čo hľadáte')"
          :action="useNamedRoutes({ name: 'search' })"
        />
      </div>
    </div>
    <div class="pt-12 pt-md-20 border-top mt-20 mt-md-40">
      <LazyWidgetHelpdeskExt />
    </div>
  </article>
</template>
